import { NgClass } from '@angular/common';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'app-info-item',
  standalone: true,
  imports: [NgClass],
  templateUrl: './info-item.component.html',
  styleUrl: './info-item.component.css',
})
export class InfoItemComponent {
  @Input() icon = '';
  @Input() label = '';
  @Input() value?: any;
  @Input() status?: boolean;

  get displayValue(): string {
    if (this.value === null || this.value === undefined || this.value === '') {
      return '—';
    }
    return this.value;
  }
}
